export default __webpack_public_path__ + "static/media/snowflake.e23b566a.svg";